import { execFile } from "node:child_process";
import { promisify } from "node:util";
import type { BootLogger } from "./types.js";

/**
 * The injectable exec seam shared across the boot steps (home reclaim, sshd,
 * user-home wiring). Formerly lived in a `self-update` module alongside an npm
 * preflight; the runtime self-update is gone (the pod runs the baked agent —
 * see boot/index.ts), so this is now purely the exec plumbing.
 */
export interface ExecDeps {
  exec(cmd: string, args: string[], opts: { timeoutMs: number }): Promise<{ stdout: string }>;
  log: BootLogger;
}

const execFileAsync = promisify(execFile);

export function defaultExec(
  cmd: string,
  args: string[],
  opts: { timeoutMs: number },
): Promise<{ stdout: string }> {
  return execFileAsync(cmd, args, { timeout: opts.timeoutMs });
}
